import styles from "./index.module.css";

export default function Permutation(props) {
  return (
    <div className={styles.product}>
      {props.image ? <div className={styles["product--image--container"]}><img src={props.image ?? ""} className={styles["product--image"]} /></div> : <div className={styles["product--image"]}></div>}

      <div className={styles["product--text"]}>
        <div className={styles["title-cost--wrapper"]}>
          <span>{props.title}</span>
          <span>{props.price}</span>
        </div>
        <div className={styles.divider}></div>
        <p className={styles["product--description"]}>{props.description}</p>
      </div>
    </div>
  )
}